import React from "react";
import { Grid, Typography, Box, useTheme } from "@mui/material";
import { CompanyDetails } from "../../../../../../types/companies-managment/Company";
import MainCard from "../../../../../../components/MainCard";
import { Link } from "react-router-dom";

interface CompanyContactInfoProps {
  company: CompanyDetails;
}

const CompanyContactInfo: React.FC<CompanyContactInfoProps> = ({ company }) => {
  const theme = useTheme();

  return (
    <MainCard title="Company contact information">
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "1rem",
            gap: "1rem",
          }}
        >
          {company?.country_name && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "40%" }}>
                Country english name :
              </Typography>
              <Typography sx={{ width: "60%" }}>
                {company?.country_name}
              </Typography>
            </Box>
          )}
          {company?.country_name_trans && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "40%" }}>
                Country arabic name :
              </Typography>
              <Typography sx={{ width: "60%" }}>
                {company?.country_name_trans?.ar}
              </Typography>
            </Box>
          )}
          {company?.city_name && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "40%" }}>
                City english name :
              </Typography>
              <Typography sx={{ width: "60%" }}>
                {company?.city_name}
              </Typography>
            </Box>
          )}
          {company?.city_name_trans && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "40%" }}>
                City arabic name :
              </Typography>
              <Typography sx={{ width: "60%" }}>
                {company?.city_name_trans?.ar}
              </Typography>
            </Box>
          )}
          {company?.nationality?.name && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "40%" }}>
                Nationality english name :
              </Typography>
              <Typography sx={{ width: "60%" }}>
                {company?.nationality?.name}
              </Typography>
            </Box>
          )}
          {company?.nationality?.name_trans && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "40%" }}>
                Nationality arabic name :
              </Typography>
              <Typography sx={{ width: "60%" }}>
                {company?.nationality?.name_trans?.ar}
              </Typography>
            </Box>
          )}
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "1rem",
            gap: "1rem",
          }}
        >
          {company?.email && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "40%" }}>
                Email :
              </Typography>
              <Typography sx={{ width: "60%" }}>{company?.email}</Typography>
            </Box>
          )}
          {company?.phone_number && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "40%" }}>
                Phone number :
              </Typography>
              <Typography sx={{ width: "60%" }}>
                {company?.phone_number}
              </Typography>
            </Box>
          )}
          {company?.post_office && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "40%" }}>
                Post office :
              </Typography>
              <Typography sx={{ width: "60%" }}>
                {company?.post_office}
              </Typography>
            </Box>
          )}
          {company?.url && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "40%" }}>
                Url :
              </Typography>
              <Typography sx={{ width: "60%" }}>
                <Link
                  to={
                    company?.url.startsWith("http")
                      ? company?.url
                      : `https://${company?.url}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    wordBreak: "break-all",
                    color: theme.palette.primary.main,
                    textDecoration: "none",
                  }}
                >
                  {company?.url}
                </Link>
              </Typography>
            </Box>
          )}
          {company?.commercial_register && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "40%" }}>
                Commercial register :
              </Typography>
              <Typography sx={{ width: "60%" }}>
                {company?.commercial_register}
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    </MainCard>
  );
};

export default CompanyContactInfo;
